/**
 * Baixa um arquivo por navegação a um link assinado (o S3 responde com `Content-Disposition: attachment`): o navegador
 * entrega o arquivo ao gerenciador de downloads, sem carregá-lo na memória da página, mesmo com centenas de MB. Nunca
 * por `HttpClient` com `blob`.
 */
export function downloadByLink(url: string, filename?: string | null, doc: Document = document): void {
	const anchor = doc.createElement('a')
	anchor.href = url
	anchor.rel = 'noopener'
	if (filename) anchor.download = filename

	doc.body.appendChild(anchor)
	anchor.click()
	anchor.remove()
}
